import styles from "./styles.module.scss";

const REVIEWS = {
  easyfit: [
    {
      name: "Grace",
      text: "I've been using this app for a couple of weeks now, and I'm already seeing results! The workouts are diverse and manageable for all fitness levels. Definitely recommend it for anyone looking to get fit and stay motivated.",
    },
    {
      name: "Charlotte",
      text: "As a full-time employee and a mom, finding time for workouts can be tough. This app has been a game-changer! The personalization and flexibility in exercise types make it easy to stay consistent.",
    },
    {
      name: "Emma",
      text: "With this program I've seen significant gains in my strength and muscle definition. It's like having your own personal coach available 24/7 and catering to all your needs!",
    },
  ],

  walky: [
    {
      name: "Johnson E.",
      text: "I’ve never stuck with a fitness routine for more than a few weeks, but Walky keeps me coming back. The variety of pace changes, the encouragement and challenges make it exciting. It’s not just walking — it’s something I now genuinely enjoy every day.",
    },
    {
      name: "Williams O.",
      text: "I’m not tech-savvy, but Walky is incredibly easy to use. I love seeing my step count and progress charts. It’s motivating to watch my stats improve week after week!",
    },
    {
      name: "Davis M.",
      text: "I’ve tried so many programs that felt overwhelming, but Walky is different. The walking plans are realistic and I’ve managed to lose weight without feeling restricted or exhausted.",
    },
  ],
};

export const Reviews = ({ isWalky }) => {
  const reviews = isWalky ? REVIEWS.walky : REVIEWS.easyfit;

  return (
    <section className={styles.reviews}>
      <div className={styles.reviewsContent}>
        <h2 className={styles.title}>Users love our plans</h2>
        <div className={styles.cards}>
          {reviews.map((review, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.name}>{review.name}</div>
              <div className={styles.stars}>
                <span>★★★★★</span>
              </div>
              <div className={styles.paragraph}>{review.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
